import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useLanguage } from '../context/LanguageContext';
import { setupOnlineOfflineListeners } from '../utils/serviceWorkerHandler';

const NetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const { language } = useLanguage();

  // الرسائل حسب اللغة - استخدام useMemo لتجنب إعادة الإنشاء في كل عملية تحديث
  const messages = React.useMemo(() => ({
    online: {
      ar: 'تم استعادة الاتصال بالإنترنت',
      en: 'Internet connection restored'
    },
    offline: {
      ar: 'انقطع الاتصال بالإنترنت. التطبيق يعمل في وضع عدم الاتصال.',
      en: 'You are offline. App is running in offline mode.'
    },
    offlineFeatures: {
      ar: 'بعض الميزات قد لا تكون متاحة في وضع عدم الاتصال.',
      en: 'Some features may not be available while offline.'
    }
  }), []);

  // Store messages in a ref to avoid dependency changes
  const messagesRef = React.useRef(messages);
  
  // Update the ref when language changes
  useEffect(() => {
    messagesRef.current = messages;
  }, [messages]);
  
  useEffect(() => {
    // تجنب إظهار إشعار عند التحميل الأولي إذا كان المستخدم متصلاً
    if (isFirstLoad) {
      setIsFirstLoad(false);
      if (!navigator.onLine) {
        toast.info(messagesRef.current.offline[language], {
          autoClose: 5000,
          position: 'top-center'
        });
      }
      return;
    }

    const handleOnline = () => {
      setIsOnline(true);
      toast.success(messagesRef.current.online[language], {
        autoClose: 3000,
        position: 'top-center'
      });
    };

    const handleOffline = () => {
      setIsOnline(false);
      const offlineToast = toast.error(messagesRef.current.offline[language], {
        autoClose: false,
        position: 'top-center'
      });
      
      // إظهار معلومات إضافية بعد فترة قصيرة
      setTimeout(() => {
        toast.info(messagesRef.current.offlineFeatures[language], {
          autoClose: 5000,
          position: 'top-center'
        });
      }, 1000);
    };

    // استخدام مكتبة serviceWorkerHandler لإدارة حالة الاتصال
    const removeListeners = setupOnlineOfflineListeners(handleOnline, handleOffline);

    return () => {
      removeListeners();
    };
  }, [isFirstLoad, language]); // Removed messages from dependencies

  // إضافة مؤشر بصري لحالة الاتصال
  return (
    <div
      style={{
        position: 'fixed',
        top: '10px',
        right: language === 'ar' ? '10px' : 'auto',
        left: language === 'ar' ? 'auto' : '10px',
        zIndex: 9999,
        display: isOnline ? 'none' : 'flex',
        alignItems: 'center',
        padding: '8px 12px',
        backgroundColor: '#f44336',
        color: 'white',
        borderRadius: '4px',
        fontSize: '14px',
        boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
        opacity: 0.9
      }}
    >
      <span
        style={{
          width: '10px',
          height: '10px',
          backgroundColor: isOnline ? '#4caf50' : '#f44336',
          borderRadius: '50%',
          marginRight: '8px',
          marginLeft: '8px'
        }}
      />
      {isOnline ? '' : (language === 'ar' ? 'غير متصل' : 'Offline')}
    </div>
  );
};

export default NetworkStatus;